import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useHistory, useNavigate } from 'react-router-dom';
import APIRequests from '../../../utility/APIRequests';
import Helper1, { notify } from '../../../utility/Helper1';
import { useSelector, useDispatch } from 'react-redux';
import { addUrlToPath } from '../../../utility/Helper1'
import { userSelect, allRemoteSettingsSelect } from '../../../redux/selectors/index';
import { authActions } from '../../../redux/actions';

import { WebLink, SiteWide, Images } from "../../../utility/customComponents";
import { AiFillCloseCircle } from "react-icons/ai";
import { ArrowLeft, Leaf } from "lucide-react"



const AuthHolder = (props) => {

    const navigate = useNavigate();

    const site_settings = useSelector(allRemoteSettingsSelect);

    return (

        <SiteWide pageTitle={props.title} themeColor={"#01131d"}>
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-green-100 p-4">


                <div className="w-full max-w-md">
                    {/* <div className="flex justify-center mb-6">
                        <div className="bg-green-600 p-3 rounded-full shadow-lg">
                            <Leaf className="h-8 w-8 text-white" />
                        </div>
                    </div> */}
                    <div className="border-none shadow-xl bg-white/90 backdrop-blur-sm rounded-lg overflow-hidden">

                        {props.children}


                    </div>
                </div>
            </div>
        </SiteWide>
    );
};

export default AuthHolder;